/* Sticky presentation only; native CSS owns scrolling and the grid boundary. */
(function () {
  function initializeStickyGallery() {
    var root = document.querySelector('#product-product.wwh-product-page');
    var main = root && root.querySelector('.wwh-pdp-main');
    var gallery = main && main.querySelector(':scope > .product-image-main');
    var information = main && main.querySelector(':scope > .product-info-main');
    if (!gallery || !information || !gallery.querySelector('.wwh-pdp-thumbnail-rail') || !window.ResizeObserver) return;
    var desktop = window.matchMedia('(min-width: 1024px)');
    var navigation = document.querySelector('#shopify-section-header .wwh-header .top-menu');
    var scheduled = false;
    function update() {
      scheduled = false;
      var top = 24;
      if (navigation) {
        var style = getComputedStyle(navigation);
        if (style.position === 'fixed' || style.position === 'sticky') {
          top += navigation.getBoundingClientRect().height + Math.max(0, parseFloat(style.top) || 0);
        }
      }
      var height = gallery.getBoundingClientRect().height;
      var fits = desktop.matches && height > 0 && height + top + 24 <= window.innerHeight &&
        information.getBoundingClientRect().height > height + 1;
      gallery.style.setProperty('--wwh-pdp-gallery-top', top + 'px');
      gallery.classList.toggle('wwh-pdp-gallery--sticky', fits);
    }
    function scheduleUpdate() {
      if (!scheduled) {
        scheduled = true;
        requestAnimationFrame(update);
      }
    }
    var observer = new ResizeObserver(scheduleUpdate);
    observer.observe(gallery);
    observer.observe(information);
    if (navigation) observer.observe(navigation);
    window.addEventListener('resize', scheduleUpdate, { passive: true });
    desktop.addEventListener('change', scheduleUpdate);
    update();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeStickyGallery, { once: true });
  } else {
    initializeStickyGallery();
  }
})();

/* Theme-owned technical navigation/accordions only. No purchasing or app event hooks. */
(function () {
  function initializeAccordions() {
    var root = document.querySelector('#product-product.wwh-product-page');
    if (!root) return;
    var technical = root.querySelector('.wwh-pdp-technical');
    if (!technical || technical.dataset.pdpReady) return;
    var desktop = window.matchMedia('(min-width: 992px)');
    var sections = [];
    technical.querySelectorAll('[data-pdp-accordion]').forEach(function (section) {
      var button = section.querySelector('.wwh-pdp-accordion-heading button');
      var panel = section.querySelector('.wwh-pdp-accordion-panel');
      if (!button || !panel || button.dataset.pdpReady) return;
      button.dataset.pdpReady = 'true';
      button.id = panel.id + '-trigger';
      panel.setAttribute('role', 'region');
      panel.setAttribute('aria-labelledby', button.id);
      panel.dataset.pdpTitle = button.textContent.trim();
      panel.tabIndex = -1;
      section.style.setProperty('--pdp-nav-row', sections.length);
      var record = { button: button, panel: panel, mobileExpanded: false };
      sections.push(record);
      button.addEventListener('click', function () {
        if (desktop.matches) selected = sections.indexOf(record);
        else record.mobileExpanded = !record.mobileExpanded;
        update();
      });
      button.addEventListener('keydown', function (event) {
        if (!desktop.matches || ['ArrowDown', 'ArrowUp', 'Home', 'End'].indexOf(event.key) < 0) return;
        event.preventDefault();
        var index = sections.indexOf(record);
        selected = event.key === 'Home' ? 0 : event.key === 'End' ? sections.length - 1 : (index + (event.key === 'ArrowDown' ? 1 : -1) + sections.length) % sections.length;
        update();
        sections[selected].button.focus();
      });
    });
    if (!sections.length) return;
    var selected = 0;
    function update() {
      technical.classList.toggle('wwh-pdp-technical--desktop', desktop.matches);
      sections.forEach(function (record, index) {
        var expanded = desktop.matches ? index === selected : record.mobileExpanded;
        record.button.setAttribute('aria-expanded', String(expanded));
        record.panel.hidden = !expanded;
      });
    }
    technical.dataset.pdpReady = 'true';
    technical.style.setProperty('--pdp-panel-count', sections.length);
    desktop.addEventListener('change', update);
    root.querySelectorAll('[data-pdp-open-panel]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var index = sections.findIndex(function (record) { return '#' + record.panel.id === link.getAttribute('href'); });
        if (index < 0) return;
        event.preventDefault();
        selected = index;
        sections[index].mobileExpanded = true;
        update();
        sections[index].panel.focus({ preventScroll: true });
        sections[index].panel.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      });
    });
    update();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAccordions, { once: true });
  } else {
    initializeAccordions();
  }
})();

/* Highlight the displayed image without handling clicks or changing gallery engines. */
(function () {
  function initializeThumbnailHighlight() {
    var root = document.querySelector('#product-product.wwh-product-page');
    var gallery = root && root.querySelector('.product-zoom-image');
    if (!gallery) return;
    function imageKey(url) {
      return (url || '').split('?')[0].split('/').pop().replace(/_\d+x\d*(?=\.[^.]+$)/, '');
    }
    function updateHighlight() {
      var image = gallery.querySelector('img');
      if (!image) return;
      var key = imageKey(image.getAttribute('src') || image.getAttribute('data-src'));
      root.querySelectorAll('.additional-images a.sub-image').forEach(function (thumbnail) {
        thumbnail.setAttribute('aria-current', String(imageKey(thumbnail.getAttribute('href')) === key));
      });
    }
    updateHighlight();
    new MutationObserver(updateHighlight).observe(gallery, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'data-src']
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeThumbnailHighlight, { once: true });
  } else {
    initializeThumbnailHighlight();
  }
})();
